// The rules of a visa (migration 017) in the CMS's words: when to apply, how
// the appointment is booked, who submits, a paper signature, the applicant's
// own email. Shared by the country page ("How each visa works here") and the
// case screen.

// "6 months", "15 days", "3 weeks": a number of days before travel, as said.
export const daysBefore = (days) => {
  const n = Number(days);
  if (n % 30 === 0 && n >= 60) return `${n / 30} months`;
  if (n % 7 === 0 && n >= 14) return `${n / 7} weeks`;
  return `${n} day${n === 1 ? "" : "s"}`;
};

export const blank = (v) => v === "" || v === null || v === undefined;

/** "Apply 6 months to 15 days before travel", or null when not set (migration 017). */
export function windowLabel(earliest, latest) {
  if (!blank(earliest) && !blank(latest)) return `Apply ${daysBefore(earliest)} to ${daysBefore(latest)} before travel`;
  if (!blank(earliest)) return `Apply at most ${daysBefore(earliest)} before travel`;
  if (!blank(latest)) return `Apply at least ${daysBefore(latest)} before travel`;
  return null;
}

const BOOKING_CHIPS = { online: "Appointment booked online", email: "Appointment booked by email", phone: "Appointment booked by phone" };

/** The visa's rules as short chips. */
export function ruleChips(visa) {
  return [
    windowLabel(visa.apply_earliest_days, visa.apply_latest_days),
    BOOKING_CHIPS[visa.appointment_booking],
    visa.submitted_by === "applicant" ? "Applicant goes in person" : visa.submitted_by === "safrati" ? "Safrati submits for them" : null,
    Number(visa.paper_signature) === 1 ? "Signed on paper too" : null,
    Number(visa.applicant_email) === 1 ? "Applicant’s own email" : null,
    waitLabel(visa),
    Number(visa.diy_minutes) > 0 ? `About ${Math.round((Number(visa.diy_minutes) / 60) * 10) / 10} h alone` : null,
  ].filter(Boolean);
}

/** Why the application window can't be saved, or null. */
export const windowError = (earliest, latest) =>
  !blank(earliest) && !blank(latest) && Number(latest) > Number(earliest)
    ? "“At least” can’t be more days before travel than “at most”."
    : null;


const isoDay = (value) => (value ? String(value).slice(0, 10) : null);
const shortDay = (iso) => {
  const [y, m, d] = String(iso).split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });
};
const daysSince = (iso, today) => Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${iso}T00:00:00Z`)) / 86400000);

/**
 * The soonest appointment as staff last checked it (migration 020), in
 * words: "Soonest appointment in 20 days (checked 20 Oct)", with "too old
 * to use" past 30 days, or null when not set.
 */
export function waitLabel(visa, today = new Date().toISOString().slice(0, 10)) {
  if (blank(visa?.appointment_wait_days)) return null;
  const on = isoDay(visa.appointment_wait_on);
  const days = Number(visa.appointment_wait_days);
  const when = days === 0 ? "Appointments available now" : `Soonest appointment in ${days} day${days === 1 ? "" : "s"}`;
  if (!on) return when;
  const old = daysSince(on, today) > 30;
  return `${when} (checked ${shortDay(on)}${old ? ", too old to use" : ""})`;
}
